import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { sanitizeHtml } from './utils/sanitize'
import "./assets/css/style.css"

Vue.config.productionTip = false

// Harden cookies: only sent over HTTPS (in production) and not attached to
// cross-site requests. Sensitive values (e.g. accessToken) live in cookies, so
// this limits their exposure. Secure is disabled on plain-HTTP dev so the flow
// keeps working with `npm run serve`.
VueCookies.config('1d', '', '', window.location.protocol === 'https:', 'Strict')

// Make sanitizeHtml available in all templates as $sanitize for v-html bindings.
Vue.prototype.$sanitize = sanitizeHtml

const Api = require('./api.js').Api;
export const api = new Api();

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
